import React from 'react';

import './index.scss';

const Notes = ({notes}) => {
  return (
    <div className="client-profile__card">
      <h1 className="client-profile__card__heading">Notes</h1>
      <div className="client-profile__card__content">
        <p className="client-profile__card__content__text">
          {notes}
        </p>
      </div>
    </div>
  );
};

export default Notes;
